import React from 'react'
import { useTranslation } from 'react-i18next'
import { Navigate, useLocation } from 'react-router-dom'

import { goTo } from 'browser-history'
import { PageId } from 'page-constants'

import { FemiButton } from '../../components/FemiButton'
import { FemiFeedbackPopup } from '../../components/FemiFeedbackPopup'
import { FemiPageContainer } from '../../components/FemiPageContainer'
import { useCancelSubscription } from '../../hooks/useCancelSubscription'
import { FemiContent } from '../../styles'
import { StyledFemiCancelConfirmation as S } from './FemiCancelConfirmation.styles'

export const FemiCancelConfirmation: React.FC = () => {
  const { search } = useLocation()
  const { t } = useTranslation()
  const {
    isUsUser,
    isFeedbackPopupShown,
    askFeedback,
    closeFeedbackPopup,
    cancelSubscription,
  } = useCancelSubscription()

  const keepSubscription = () => {
    goTo(
      { pathname: PageId.CONTINUED_SUBSCRIPTION, search },
      { isPlanKept: true },
    )
  }

  if (isUsUser) {
    return (
      <Navigate
        to={{ pathname: `/${PageId.SUBSCRIPTION_DETAILS}`, search }}
        replace
      />
    )
  }

  return (
    <FemiPageContainer hasNavigation>
      <FemiContent>
        <S.Title>{t('retention.femi.cancelConfirmation.title')}</S.Title>
        <S.Description>
          {t('retention.femi.cancelConfirmation.description')}
        </S.Description>
        <S.Losses>
          {(
            t('retention.femi.cancelConfirmation.losses', {
              returnObjects: true,
            }) as string[]
          ).map((text) => (
            <S.Loss key={text}>{text}</S.Loss>
          ))}
        </S.Losses>
        <S.Buttons>
          <FemiButton type="button" onClick={keepSubscription}>
            {t('retention.femi.cancelConfirmation.keepPlan')}
          </FemiButton>
          <FemiButton type="button" variant="secondary" onClick={askFeedback}>
            {t('retention.femi.cancelConfirmation.cancelPlan')}
          </FemiButton>
        </S.Buttons>
      </FemiContent>
      <FemiFeedbackPopup
        isShown={isFeedbackPopupShown}
        onComplete={cancelSubscription}
        onClose={closeFeedbackPopup}
      />
    </FemiPageContainer>
  )
}
